import React from "react";
import { CheckCircle2, XCircle } from "lucide-react";

export function BooleanIndicators({
  items,
}: {
  items: Array<{ label: string; ok: boolean }>;
}) {
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      {items.map((item) => (
        <div
          key={item.label}
          className="border-base-border flex items-center gap-2 rounded-lg border bg-white p-3 text-sm text-black/96"
        >
          {item.ok ? (
            <CheckCircle2 className="text-light-green size-4 shrink-0" />
          ) : (
            <XCircle className="text-custom-destructive-dark size-4 shrink-0" />
          )}
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
}
